import React, { useState } from 'react'
import { SearchResultPartyDetails } from '@Entities/party-details'
import SelectWritersStep from '@Scenes/SongwriterScene/SongwriterMyWritersScene/SongwriterRequestUpdateSidebar/MergeWriterNamesForm/SelectWritersStep'
import SelectPrimaryWriterStep from '@Scenes/SongwriterScene/SongwriterMyWritersScene/SongwriterRequestUpdateSidebar/MergeWriterNamesForm/SelectPrimaryWriterStep'
import MergeSummaryStep from '@Scenes/SongwriterScene/SongwriterMyWritersScene/SongwriterRequestUpdateSidebar/MergeWriterNamesForm/MergeSummaryStep'
import './index.scss'

export interface MergeWriterNamesSelection {
    primaryWriter: SearchResultPartyDetails
    writersToMerge: SearchResultPartyDetails[]
}

interface MergeWriterNamesFormProps {
    writers: SearchResultPartyDetails[]
    initiallySelectedWriterIpId?: string
    onBack(): void
    onSubmit(selection: MergeWriterNamesSelection): void
}

type MergeStep = 'selectWriters' | 'selectPrimary' | 'summary'

const MergeWriterNamesForm = (props: MergeWriterNamesFormProps) => {
    const { writers, initiallySelectedWriterIpId, onBack, onSubmit } = props
    const [step, setStep] = useState<MergeStep>('selectWriters')
    const [selectedWriterIpIds, setSelectedWriterIpIds] = useState<string[]>(
        initiallySelectedWriterIpId ? [initiallySelectedWriterIpId] : []
    )
    const [primaryWriterIpId, setPrimaryWriterIpId] = useState<string | null>(null)

    const selectedWriters = writers.filter((writer) => selectedWriterIpIds.includes(String(writer.ipId)))
    const primaryWriter = selectedWriters.find((writer) => String(writer.ipId) === primaryWriterIpId)
    const writersToMerge = selectedWriters.filter((writer) => writer !== primaryWriter)

    const toggleWriter = (writerIpId: string) => {
        setSelectedWriterIpIds((current) =>
            current.includes(writerIpId) ? current.filter((id) => id !== writerIpId) : [...current, writerIpId]
        )
        if (primaryWriterIpId === writerIpId) {
            setPrimaryWriterIpId(null)
        }
    }

    return (
        <div className="merge-writer-names-form">
            <h2>Merge Writer Names</h2>
            <p>To submit a request to update songwriter information, please answer a few questions below.</p>
            {step === 'selectWriters' && (
                <SelectWritersStep
                    writers={writers}
                    selectedWriterIpIds={selectedWriterIpIds}
                    toggleWriter={toggleWriter}
                    onBack={onBack}
                    onNext={() => setStep('selectPrimary')}
                />
            )}
            {step === 'selectPrimary' && (
                <SelectPrimaryWriterStep
                    writers={selectedWriters}
                    primaryWriterIpId={primaryWriterIpId}
                    setPrimaryWriterIpId={setPrimaryWriterIpId}
                    onBack={() => setStep('selectWriters')}
                    onNext={() => setStep('summary')}
                />
            )}
            {step === 'summary' && primaryWriter && (
                <MergeSummaryStep
                    primaryWriter={primaryWriter}
                    writersToMerge={writersToMerge}
                    onBack={() => setStep('selectPrimary')}
                    onSubmit={() => onSubmit({ primaryWriter, writersToMerge })}
                />
            )}
        </div>
    )
}
export default MergeWriterNamesForm
